export const BOOT_COUNTDOWN_SECONDS = 60;
export const BOOT_ONLINE_INITIAL_PROGRESS = 8;
export const BOOT_OFFLINE_INITIAL_PROGRESS = 100;

export const PRELOGIN_STAGE_LABELS = Object.freeze({
  "checking-version": "Verificando versão do aplicativo",
  "validating-install": "Validando instalação do banco de dados",
  "updating-version": "Aplicando nova versão do aplicativo",
  "pulling-global": "Atualizando fazendas e contas do dispositivo",
  "syncing-farms": "Sincronizando dados das fazendas",
  "syncing-catalogs": "Atualizando catálogos globais",
  "finalizing": "Finalizando acesso",
  "done": "Acesso liberado",
  "offline-ready": "Sem internet: login liberado com dados locais",
});
